import { SchedulerCardAction } from '@src/types/scheduler-message';

const ACTION_PREFIX = '/api/mario/scheduler/';
const ACTION_METHODS = new Set(['GET', 'POST', 'PUT']);

const getPathParamKeys = (path: string) => {
  const keys: string[] = [];
  path.replace(/\{([^}]+)\}/g, (_, key) => {
    keys.push(String(key));
    return '';
  });
  return keys;
};

const fillPathParams = (path: string, params: Record<string, unknown>) => {
  return path.replace(/\{([^}]+)\}/g, (_, key) => {
    const value = params[key];
    return encodeURIComponent(String(value ?? ''));
  });
};

export const isAllowedSchedulerAction = (action: SchedulerCardAction) => {
  const method = String(action.method || 'GET').toUpperCase();
  return (
    typeof action.api === 'string' &&
    action.api.startsWith(ACTION_PREFIX) &&
    ACTION_METHODS.has(method)
  );
};

export const executeSchedulerAction = async (action: SchedulerCardAction) => {
  if (!isAllowedSchedulerAction(action)) {
    throw new Error('非法操作请求');
  }

  const method = String(action.method || 'GET').toUpperCase();
  const params = action.params || {};
  const pathParamKeys = new Set(getPathParamKeys(action.api));
  const requestParams = Object.fromEntries(
    Object.entries(params).filter(([key]) => !pathParamKeys.has(key)),
  );
  const path = fillPathParams(action.api, params);

  const requestInit: RequestInit = {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  let url = path;
  if (method === 'GET') {
    const query = new URLSearchParams();
    Object.entries(requestParams).forEach(([key, value]) => {
      if (value === undefined || value === null) {
        return;
      }
      query.set(key, String(value));
    });
    const queryString = query.toString();
    if (queryString) {
      url += `${path.includes('?') ? '&' : '?'}${queryString}`;
    }
  }
  if (method === 'POST' || method === 'PUT') {
    requestInit.body = JSON.stringify(requestParams);
  }

  const response = await fetch(url, requestInit);
  const data = await response.json().catch(() => ({}));

  const success =
    response.ok &&
    (data?.status === 0 || data?.status === 'success' || data?.code === 0);
  if (!success) {
    throw new Error(data?.message || '操作失败');
  }
  return data;
};
